module.exports = __webpack_public_path__ + "img/img11.27c1dd60.png";